/**
 * Metin güvenliği kuralları (QA Blok 1 P3 bulguları).
 *
 * Joi'siz saf fonksiyonlar: hem `contracts` içindeki şemalar hem de istemci/Edge
 * paketleri (ör. translator) tarafından kullanılabilir.
 */
/**
 * Yasak kontrol karakterleri: C0 (null bayt dahil) + DEL + C1 blokları.
 * TAB / LF / CR tek satır alanlarda da anlamsızdır; çok satırlı alanlar
 * (`bio` gibi) için `allowNewlines` seçeneği vardır.
 */
// eslint-disable-next-line no-control-regex
const CONTROL_CHARS_SINGLE_LINE = /[\u0000-\u001f\u007f-\u009f]/;
// eslint-disable-next-line no-control-regex
const CONTROL_CHARS_MULTILINE = /[\u0000-\u0008\u000b\u000c\u000e-\u001f\u007f-\u009f]/;
/**
 * Yön değiştiren / görünmez karakterler (RTL override sahteciliği + sıfır genişlik):
 * ZWSP..RLM, LRE..RLO, WJ bloğu, LRI..PDI, BOM.
 */
const BIDI_AND_INVISIBLE_CHARS = /[\u200b-\u200f\u202a-\u202e\u2060-\u2064\u2066-\u2069\ufeff]/;
/** En az bir görünür (harf/rakam/noktalama/sembol) karakter var mı? */
const PRINTABLE_CHAR = /[\p{L}\p{N}\p{P}\p{S}]/u;
export function hasForbiddenControlChars(value, allowNewlines = false) {
    const pattern = allowNewlines ? CONTROL_CHARS_MULTILINE : CONTROL_CHARS_SINGLE_LINE;
    return pattern.test(value) || BIDI_AND_INVISIBLE_CHARS.test(value);
}
export function hasPrintableCharacter(value) {
    return PRINTABLE_CHAR.test(value);
}
let cachedTimeZones = null;
/**
 * IANA saat dilimi doğrulaması (QA P3: `Europe/Atlantis` kabul ediliyordu).
 * `Intl.supportedValuesOf` birincil kaynak; listede olmayan ama geçerli takma
 * adlar (`UTC` gibi) için `DateTimeFormat` kurucusuyla yoklama yapılır.
 */
export function isValidIanaTimeZone(value) {
    if (value.length === 0 || value.length > 64)
        return false;
    try {
        if (cachedTimeZones === null && typeof Intl.supportedValuesOf === 'function') {
            cachedTimeZones = new Set(Intl.supportedValuesOf('timeZone'));
        }
    }
    catch {
        cachedTimeZones = null;
    }
    if (cachedTimeZones?.has(value))
        return true;
    try {
        new Intl.DateTimeFormat('en-US', { timeZone: value });
        return true;
    }
    catch {
        return false;
    }
}
/**
 * Takvimde gerçekten var olan ISO-8601 zaman damgası mı? (QA P3: `2026-02-30`
 * `isoDate()`ten geçiyor, JS Date 2 Mart'a yuvarlıyor, Postgres reddediyordu.)
 * Biçim denetimi Joi `isoDate()`te kalır; burada yalnızca takvim denetlenir.
 */
export function isValidCalendarIsoDate(value) {
    const match = /^(\d{4})-(\d{2})-(\d{2})(?:[T ]|$)/.exec(value);
    if (!match)
        return false;
    const y = Number(match[1]);
    const m = Number(match[2]);
    const d = Number(match[3]);
    if (m < 1 || m > 12)
        return false;
    const daysInMonth = new Date(Date.UTC(y, m, 0)).getUTCDate();
    return d >= 1 && d <= daysInMonth;
}
//# sourceMappingURL=text-rules.js.map